import { useState } from "react"
import { AppBar as MUIAppBar, Box, IconButton, Toolbar, Typography, useTheme, Tooltip } from "@mui/material"
import AppNav from "./AppNav"
import MenuIcon from '@mui/icons-material/Menu'
import { useLocation } from "react-router-dom"
import { useDispatch} from "react-redux"
import { toggleThemeModePersist } from "../../slices/themeSlice"
// import { logout } from "../../slices/authSlice"
import { appBarHeight } from "../../helpers/Layout"
// import { saveOrderNotes } from "../../slices/cartSlice"
import { toHomePage, toPage,  } from "../../actions/navigation"

import { getAssetImagesUrl } from "../../api/ApiDataHelper"
// import { ReactComponent as Logo } from "../../resources/logo.svg"
import SVG from 'react-inlinesvg'
import { changeLanguage } from "i18next"
import ChangeLocale from "./ChangeLocale"
import { useTranslation } from "react-i18next"
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js"
import NavigationComponent from "./NavigationComponent"

export default function AppBar(props) {
  const theme = useTheme()

  const dispatch = useDispatch()
  // const cartOrder = useSelector(state => state.cart.cartOrder)
  // const userData = useSelector(state => state.auth.userData)
  const { t } = useTranslation()

  const { volumeModeEnabled } = false

  const [menuCollapse, setMenuCollapse] = useState(true)

  const handleToggleMenu = () => setMenuCollapse(!menuCollapse)

  const handleClickMenuItem = page => {
    toPage(page)
    handleToggleMenu()
  }

  const handleToggleThemeMode = () => dispatch(toggleThemeModePersist())
  const handleChangeLanguage = (lang) => dispatch(changeLanguage(lang))
  // const handleLogout = () => dispatch(logout())

  const location = useLocation()


  return (
    <>
      <MUIAppBar
        elevation={0}
        sx={{
          // borderBottom: theme.palette.mode === 'dark' ?
          //   '1px solid #333'
          //   : '1px solid #ddd',
          // '@media all': {
          //   height: appBarHeight,
          // },
          zIndex: theme => theme.zIndex.drawer + 1,
          // background: `rgba(255, 255, 255, 0.3)`,
          background: `transparent`,
          pointerEvents: 'none',
          "& .gradient-blur":{
            zIndex: -1,
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            transform: "rotate(180deg)",

            "& > div, &::before, &::after": {
              position: "absolute",
              inset: 0,
            },
          "&::before": {
            content: "''",
            zIndex: "1",
            backdropFilter: "blur(0.5px)",
            backdropFilter: "blur(0.25px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 1) 12.5%,
              rgba(0, 0, 0, 1) 25%,
              rgba(0, 0, 0, 0) 37.5%
            )`
          },
          "& > div:nth-of-type(1)": {
            zIndex: 2,
            backdropFilter: "blur(1px)",
            backdropFilter: "blur(0.5px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 12.5%,
              rgba(0, 0, 0, 1) 25%,
              rgba(0, 0, 0, 1) 37.5%,
              rgba(0, 0, 0, 0) 50%
            )`
          },
          "& > div:nth-of-type(2)": {
            zIndex: 3,
            backdropFilter: "blur(2px)",
            backdropFilter: "blur(1px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 25%,
              rgba(0, 0, 0, 1) 37.5%,
              rgba(0, 0, 0, 1) 50%,
              rgba(0, 0, 0, 0) 62.5%
            )`
          },
          "& > div:nth-of-type(3)": {
            zIndex: 4,
            backdropFilter: "blur(4px)",
            backdropFilter: "blur(2px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 37.5%,
              rgba(0, 0, 0, 1) 50%,
              rgba(0, 0, 0, 1) 62.5%,
              rgba(0, 0, 0, 0) 75%
            )`
          },
          "& > div:nth-of-type(4)": {
            zIndex: 5,
            backdropFilter: "blur(8px)",
            backdropFilter: "blur(4px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 50%,
              rgba(0, 0, 0, 1) 62.5%,
              rgba(0, 0, 0, 1) 75%,
              rgba(0, 0, 0, 0) 87.5%
            )`
          },
          "& > div:nth-of-type(5)": {
            zIndex: 6,
            backdropFilter: "blur(16px)",
            backdropFilter: "blur(8px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 62.5%,
              rgba(0, 0, 0, 1) 75%,
              rgba(0, 0, 0, 1) 87.5%,
              rgba(0, 0, 0, 0) 100%
            )`
          },
          "& > div:nth-of-type(6)": {
            zIndex: 7,
            backdropFilter: "blur(32px)",
            backdropFilter: "blur(16px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 75%,
              rgba(0, 0, 0, 1) 87.5%,
              rgba(0, 0, 0, 1) 100%
            )`
          },
          "&::after": {
            content: "''",
            zIndex: 8,
            backdropFilter: "blur(64px)",
            backdropFilter: "blur(32px)",
            mask: `linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 87.5%,
              rgba(0, 0, 0, 1) 100%
            )`
          }
        },
        }}
      >
        <Toolbar sx={{
          '@media all': { minHeight: `calc(${appBarHeight} - 40px)`},
          // backdropFilter: 'blur(10px)',
          margin: "8px",
          [theme.breakpoints.up('md')]: {
            margin: "16px",
          },
          // backdropFilter: 'invert(100%)',
        }}>
          {/* <IconButton
            sx={{
              marginRight: 2,
              [theme.breakpoints.up('lg')]: {
                display: "none"
              }
            }}
            onClick={handleToggleMenu}
          >
            <MenuIcon />
          </IconButton> */}
          {/* <Tooltip title={t("label_back_to_homepage")}
              placement="right"
              disableInteractive
              disableTouchListener
              sx={{
              pointerEvents: "auto"}}> */}
          <Box
            sx={{
              pointerEvents: "auto",
              maskImage: `url('data:image/svg+xml;utf8,<svg viewBox="0 0 3062 3062" xmlns="http://www.w3.org/2000/svg" ><path id="BLACK" d="M1491.84,2712.78C1476,2760.02 1426.68,2819.9 1373.07,2775.89C1337.78,2746.91 1408.87,2677.62 1428.26,2675.46C1428.26,2675.46 909.419,2660.71 789.707,2598.53C684.373,2543.83 696.515,2194.83 696.515,2194.83C696.515,2194.83 639.208,2290.16 593.928,2319.01C548.033,2348.26 421.149,2370.3 421.149,2370.3C421.149,2370.3 330.261,2232.62 418.45,2073.34C461.06,1996.38 691.116,1916.76 691.116,1916.76C691.116,1916.76 356.396,1999.93 275.368,1887.07C179.53,1753.58 93.14,1316.81 116.087,1115.83C135.992,941.492 413.05,681.183 413.05,681.183C413.05,681.183 416.506,1023.19 456.245,1096.93C480.537,1142.01 585.599,1133.01 630.743,1126.86C645.401,1131.85 630.743,1126.86 630.743,1126.86C630.743,1126.86 617.975,1120.94 609.478,1113.67C525.899,1042.13 627.744,936.747 680.317,996.176C680.317,996.176 663.06,936.909 664.659,883.007C669.206,729.729 832.519,709.588 886.247,799.101C917.415,851.027 880.524,936.136 880.524,936.136C880.524,936.136 1209.62,746.357 1347.13,680.316C1517.14,598.672 2063.05,467.413 2143.53,526.435C2170.4,581.505 2061.78,684.638 1995.05,718.111C1995.05,718.111 2426.1,673.567 2464.79,742.408C2503.49,811.25 2227.22,1131.16 2227.22,1131.16C2227.22,1131.16 2382.45,1157.71 2435.1,1152.76C2474.77,1149.03 2527.16,1137.99 2543.08,1101.46C2576.83,1024.07 2637.57,688.415 2637.57,688.415C2637.57,688.415 2834.36,936.585 2842.75,1085.27C2854.45,1292.69 2793.25,1780.43 2707.76,1932.96C2645.19,2044.6 2363.06,2004.01 2363.06,2004.01C2363.06,2004.01 2552.98,2035.21 2607.88,2101.01C2662.77,2166.82 2659.17,2395.28 2659.17,2395.28C2659.17,2395.28 2533.17,2394.64 2456.02,2380.47C2454.93,2402.91 2450.71,2434.7 2438.25,2446.66C2421.2,2463.02 2374.67,2470.85 2353.93,2459.1C2333.2,2447.35 2311.55,2401.51 2313.85,2376.17C2315.41,2358.95 2333.77,2337.91 2349.43,2323.01C2313.63,2290.56 2283.92,2254.89 2283.92,2254.89C2283.92,2254.89 2292.93,2586.85 2201.52,2632.47C2097,2684.64 1648.18,2676.34 1648.18,2676.34C1667.83,2684.14 1726.38,2728.13 1680.99,2773.23C1648.37,2805.64 1591.94,2727.3 1571.15,2701.58C1570.35,2700.28 1589.89,2852.92 1532.91,2838.33C1482.36,2825.39 1492.27,2710.83 1491.84,2712.78ZM1966.89,1491.35C1877.44,1415.43 1701.63,1434.27 1636.39,1612.42C1567.4,1800.83 1610.3,2250.93 1629.43,2349.84C1648.14,2446.57 1813.11,2487.56 1894.1,2497.46C1975.09,2507.36 2054.83,2460.6 2110.18,2391.96C2166.43,2322.22 2229.74,2207.67 2212.55,2101.47C2187.81,1948.49 2062.91,1572.86 1966.89,1491.35ZM1626.28,2472.46C1576.2,2485.51 1554.16,2513.05 1566.27,2536.44C1572.22,2547.92 1597.16,2558.23 1610.43,2562.48C1650.52,2575.33 1705.95,2541.64 1689.69,2503.6C1683.15,2488.28 1649.95,2466.3 1626.28,2472.46ZM2431.23,2374.93C2426.76,2373.69 2422.62,2372.38 2418.9,2370.98C2404.06,2365.43 2387.52,2354.57 2371.24,2341.62C2359.65,2354.93 2346.91,2369.81 2344.26,2380.32C2339.93,2397.41 2349.1,2424.32 2362.23,2430.08C2375.36,2435.83 2411.07,2428 2423.04,2414.87C2430.05,2407.19 2430.75,2389.82 2431.23,2374.93ZM1041.03,1504.85C945.006,1586.36 828.75,1922.25 804.003,2075.23C786.824,2181.43 846.676,2318.44 902.919,2388.18C958.274,2456.82 1046.65,2501.85 1127.64,2491.95C1208.63,2482.05 1354.6,2430.7 1373.31,2333.97C1392.44,2235.06 1440.52,1814.32 1371.53,1625.92C1306.29,1447.77 1130.48,1428.93 1041.03,1504.85ZM1435.14,2472.46C1411.47,2466.3 1378.27,2488.28 1371.73,2503.6C1355.47,2541.64 1410.9,2575.33 1450.99,2562.48C1464.26,2558.23 1489.2,2547.92 1495.15,2536.44C1507.26,2513.05 1485.22,2485.51 1435.14,2472.46Z"/></svg>')`,
              maskSize: "contain",
              // background: "red ",
              height: "40px",
              width: "40px",
              backdropFilter: 'invert(100%)',
              "svg": {
                height: "40px",
                // fill: theme.palette.background.default
              },
              "&:hover": {
                cursor: 'pointer'
              }
            }}
            onClick={volumeModeEnabled ? null : toHomePage}
          >
            {/* <SVG src={getAssetImagesUrl("logo.svg")} /> */}
            {/* <Logo /> */}
          </Box>
          {/* </Tooltip> */}

          <Box sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            ml: "auto",
            pointerEvents: "auto",
            borderRadius: "40px",
            backdropFilter: 'blur(10px)',
            backgroundColor: theme.palette.grey.transparent,
            p: "10px"
          }}>
            {/* <Typography variant="h6">
              {t("label_footer_name_salute")}
            </Typography>
            */}
            <ChangeLocale />

            <NavigationComponent />

          </Box>
          {/* <Box sx={{ [theme.breakpoints.down('lg')]: { display: "none" } }}>
            <AppNav
              visible
              disabled={volumeModeEnabled}
              page={location.pathname}
              handleToPage={toPage}
              handleClickMenuItem={handleClickMenuItem}
            />
          </Box> */}
          {/* {cartIconVisible &&
            <Box sx={{
              ml: 2,
              [theme.breakpoints.down('lg')]: { marginRight: 0 }
            }}>
              <CartButton
                disabled={volumeModeEnabled}
                badgeContent={cartQuantity}
                onClick={toCartPage}
              />
            </Box>
          } */}

        </Toolbar>
        <Box
        className="gradient-blur"
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </Box>
      </MUIAppBar>
    </>
  )
}
